<div class="confirm-dialog">
  <div class="dialog-header">
    <i [class]="getIconClass()" [style.color]="getIconColor()"></i>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  <div mat-dialog-content class="dialog-content">
    <p>{{ data.message }}</p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-btn"
            [disabled]="isCancelLoading">
      <span *ngIf="isCancelLoading" class="btn-spinner"></span>
      <span *ngIf="!isCancelLoading">{{ data.cancelText }}</span>
    </button>
    <button mat-raised-button color="primary" (click)="onConfirm()" class="confirm-btn" cdkFocusInitial
            [disabled]="isCancelLoading">
      {{ data.confirmText }}
    </button>
  </div>
</div>
